<template>

  <!-- <v-container v-if="Object.keys(pattern).length != 0" fluid> -->
  <v-container fluid>
<!-- {{online}} -->
<!-- {{userId}} -->
<!-- {{orgId}} -->
<!-- {{cardsList}} -->
<!-- 
<br>
<v-btn @click="loadDictStatus">load</v-btn>
{{dictStatus}}
{{dictStatus.status}}
 -->
<!-- <br> -->
<!-- <v-btn @click="getDictionary('status')">load status</v-btn> -->

<!-- <br> -->
<!-- <v-btn @click="loadCardsList">load all cards</v-btn> -->
<!-- <pre>{{JSON.stringify(cardsList, null, 2)}}</pre> -->

<!-- <v-btn @click="getDictionaries">load all dict</v-btn> -->
<!-- <pre>{{JSON.stringify(dictionary, null, 2)}}</pre> -->
<!-- <br> -->



      <!-- секция фильтра -->
      <v-row>
        <v-col cols="12" v-show="this.isShowFilter">
          <v-card class="pa-2">
<!--             
            <v-card-title class="justify-center ma-0">
              <span class="headline">Фильтр</span>
            </v-card-title>
 -->


            <!-- ------------------------------------------------- -->
            <v-row class="ml-2 mt-2 mr-5">

              <v-text-field
                class="mr-6"
                label="Фамилия"
                v-model="filter.P_F"
                clearable
                outlined
                dense
                style="max-width: 320px"
                ref="FamilyInput"
              ></v-text-field>
                <!-- prepend-icon="mdi-account" -->

              <v-text-field
                class="mr-6"
                label="Имя"
                v-model="filter.P_I"
                clearable
                outlined
                dense
                style="max-width: 320px"
              ></v-text-field>

              <v-text-field
                class="mr-6"
                label="Отчество"
                v-model="filter.P_O"
                clearable
                outlined
                dense
                style="max-width: 320px"
              ></v-text-field>

              <v-select
                v-model="filter.P_ID_TTYPE_CITIZEN"
                :items="this.dictionary.citizenship"
                item-text="NAME"
                item-value="ID"
                label="Гражданство"
                outlined
                required
                dense
                clearable
                style="max-width: 300px"
                :no-data-text="no_data_text"
              >
              </v-select>
              
<!-- 
              <div style="max-width:220px" class="ml-2">
                <MenuDatePicker label="Дата рождения" v-model="filter.BirthDate"></MenuDatePicker>
              </div>
 -->
            </v-row>


            <!-- ------------------------------------------------- -->
            <v-row class="ml-2 mt-2">

              <v-text-field
                class="mr-6"
                label="№ПК"
                v-model="filter.P_FANID"
                clearable
                outlined
                dense
                style="max-width: 320px"
              ></v-text-field>

              <v-text-field
                class="mr-6"
                label="№ телефона"
                v-model="filter.P_PHONE"
                clearable
                outlined
                dense
                style="max-width: 320px"
              ></v-text-field>

              <v-text-field
                class="mr-6"
                label="Почтовый адрес"
                v-model="filter.P_E_MAIL"
                clearable
                outlined
                dense
                style="max-width: 320px"
              ></v-text-field>

            </v-row>

            <!-- ------------------------------------------------- -->
            <v-row class="ml-2 mt-2">


                <v-select
                  class="mt-0 mr-6"
                  v-model="filter.P_ID_TTYPE_STATUS"
                  :items="this.dictionary.status"
                  item-text="NAME"
                  item-value="ID"
                  label="Статус документа"
                  outlined
                  required
                  dense
                  clearable
                  style="max-width: 300px"
                  :no-data-text="no_data_text"
                >
                </v-select>
                  <!-- prepend-icon="mdi-checkbox-marked-outline" -->

                <v-select
                  class="mt-0 mr-6"
                  v-model="filter.P_ID_TTYPE"
                  :items="this.dictionary.passtype"
                  item-text="NAME"
                  item-value="ID"
                  label="Тип"
                  outlined
                  required
                  dense
                  clearable
                  style="max-width: 300px"
                  :no-data-text="no_data_text"
                >
                </v-select>
 
                 <v-select
                  class="mt-0 mr-6"
                  v-model="filter.P_ID_TTYPE_CATEGOR"
                  :items="this.dictionary.category"
                  item-text="NAME"
                  item-value="ID"
                  label="Категория"
                  outlined
                  required
                  dense
                  clearable
                  style="max-width: 300px"
                  :no-data-text="no_data_text"
                >
                </v-select>
 

            </v-row>


            <!-- ------------------------------------------------- -->
            <v-row class="ml-2 mt-2">

                <date-picker
                  v-model="filter.P_DATE_BEG_1"
                  type="date"
                  format="DD.MM.YYYY"
                  placeholder="Дата начала действия, с"
                  class="mr-6"
                >
                  <template #input="{ props, events }">
                    <input
                      v-bind="props"
                      v-on="{
                        ...events,
                        input: (event) =>
                          handleDateTimeInput(event, events.input),
                      }"
                    />
                  </template>

                  <i slot="icon-calendar"
                    ><v-icon>mdi-calendar-clock</v-icon></i
                  >
                </date-picker>


                <date-picker
                  v-model="filter.P_DATE_BEG_2"
                  type="date"
                  format="DD.MM.YYYY"
                  placeholder="Дата начала действия, по"
                  class="mr-10"
                >
                  <template #input="{ props, events }">
                    <input
                      v-bind="props"
                      v-on="{
                        ...events,
                        input: (event) =>
                          handleDateTimeInput(event, events.input),
                      }"
                    />
                  </template>

                  <i slot="icon-calendar"
                    ><v-icon>mdi-calendar-clock</v-icon></i
                  >
                </date-picker>


                <date-picker
                  v-model="filter.P_DATE_END_1"
                  type="date"
                  format="DD.MM.YYYY"
                  placeholder="Дата окончания действия, с"
                  class="mr-6"
                >
                  <template #input="{ props, events }">
                    <input
                      v-bind="props"
                      v-on="{
                        ...events,
                        input: (event) =>
                          handleDateTimeInput(event, events.input),
                      }"
                    />
                  </template>

                  <i slot="icon-calendar"
                    ><v-icon>mdi-calendar-clock</v-icon></i
                  >
                </date-picker>


                <date-picker
                  v-model="filter.P_DATE_END_2"
                  type="date"
                  format="DD.MM.YYYY"
                  placeholder="Дата окончания действия, по"
                >
                  <template #input="{ props, events }">
                    <input
                      v-bind="props"
                      v-on="{
                        ...events,
                        input: (event) =>
                          handleDateTimeInput(event, events.input),
                      }"
                    />
                  </template>

                  <i slot="icon-calendar"
                    ><v-icon>mdi-calendar-clock</v-icon></i
                  >
                </date-picker>


            </v-row>


            <!-- ------------------------------------------------- -->
            <v-row class="ml-2 mt-2">
<!-- 
                <v-select
                  class="mt-0 mr-6"
                  v-model="filter.P_ID_ORG"
                  :items="this.dictionary.organization"
                  item-text="NAME"
                  item-value="ID"
                  label="Организация"
                  outlined
                  required
                  dense
                  clearable
                  style="max-width: 300px"
                  :no-data-text="no_data_text"
                >
                </v-select>
                 -->
                  <!-- prepend-icon="mdi-checkbox-marked-outline" -->

                <v-select
                  class="mt-0 mr-6"
                  v-model="filter.P_ID_EVENT"
                  :items="this.dictionary.event"
                  item-text="NAME"
                  item-value="ID"
                  label="Событие"
                  outlined
                  required
                  dense
                  clearable
                  style="max-width: 300px"
                  :no-data-text="no_data_text"
                >
                </v-select>
 
             <!-- </v-row> -->


            <!-- <v-divider class="ma-2"></v-divider> -->

            <!-- ------------------------------------------------- -->
            <!-- <v-row class="ml-2 mt-2 mr-5"> -->

              <v-select
                class="mt-0 mr-6"
                v-model="filter.PRINTED"
                :items="this.printed_items"
                item-text="NAME"
                item-value="ID"
                label="Печать"
                outlined
                required
                dense
                clearable
                style="max-width: 240px"
                :no-data-text="no_data_text"
              >
              </v-select>

              <v-select
                class="mt-0 mr-6"
                v-model="filter.UNLOADED"
                :items="this.unloaded_items"
                item-text="NAME"
                item-value="ID"
                label="Выгрузка"
                outlined
                required
                dense
                clearable
                style="max-width: 240px"
                :no-data-text="no_data_text"
              >
              </v-select>

<!-- 
              <v-checkbox
                class="ma-1"
                v-model="filter.P"
                label="Загрузить ПТД"
                dense
              ></v-checkbox>
 -->
            </v-row>





            <v-divider class="ma-2"></v-divider>

            <v-card-actions>
              <!-- <v-row align="left" justify="space-around"> -->
              <v-row>
                <v-col cols="auto" align="left">
                  <v-btn
                    color="primary"
                    @click="loadCardsList"
                    dense
                    class="ma-1"
                    :disabled="isloading"
                  >
                    <v-icon left>mdi-table-arrow-right</v-icon>
                    Выбрать данные
                     <!-- (↵) -->
                  </v-btn>
                </v-col>
                    <!-- :disabled="isloading || !(filter.Barcode || filter.Ticketid || filter.Cardid || filter.Phone || filter.RusF  || filter.RusI  || filter.RusO)" -->

                <v-col cols="auto" align="left">
                  <v-btn
                    color="primary"
                    @click="clearFilter"
                    dense
                    class="ma-1"
                    outlined
                  >
                    <v-icon left>mdi-eraser</v-icon>
                    Очистить
                     <!-- (F4) -->
                  </v-btn>
                </v-col>

<!-- 
                <v-spacer></v-spacer>

                 <v-col cols="auto" align="left">
                  <v-btn
                    color="primary"
                    class="ma-1"
                    :disabled="isloading || !currentPtd || !currentPtd.ticket_event || !currentPtd.ticket_event.isperimeteraccess"
                    ref="printTicketButton"
                    @click="onTicketPrint"
                  >
                    <v-icon center>mdi-printer</v-icon> (F9)
                  </v-btn>

                  <!- скрытая кнопка для печати ->
                  <v-btn
                    v-print="printObj"
                    v-show="false"
                    ref="printTicketButtonHidden"
                  >
                  </v-btn>

                </v-col>
 -->
 
 
              </v-row>
            </v-card-actions>



            <!-- <v-card-subtitle> -->

            <!-- {{this.logs.length}} -->
            <!-- {{this.filter_gameName}} -->

            <!-- </v-card-subtitle> -->

          </v-card>
        </v-col>
      </v-row>

      <!--   ------------------  секция данных  ---------------------  -->

      <v-row ref="datatable">
        <v-col :cols="12">
          <v-card class="mx-auto">
              <v-data-table 
                :headers="this.datatable_headers"
                :items="this.cardsList"
                :items-per-page="this.itemsPerPage"
                :page="this.currentPage"
                item-key="passid"
                locale="sessLang"
                dense
                single-select
                :loading="isloading"
                :loading-text="home_datatable_loadingtext"
                :no-data-text="home_datatable_nodataavailable"
                :footer-props="{
                  showFirstLastPage: true,
                  'items-per-page-text': this.home_datatable_itemsperpage,
                  'items-per-page-all-text': this.home_datatable_itemsperpage_all,
                  'items-per-page-options': [5, 10, 20, 50, -1],
                }"
              >
                <!-- disable-sort -->
                <!-- :item-class="itemRowBackground" -->
                <!-- @update:items-per-page="updateItemPerPage" -->
                <!-- @update:page="changePage" -->
                <!-- @click:row="rowClick" -->
<!-- 
                <template v-slot:top>
                  <v-toolbar flat>

                    <v-toolbar-title>
                      <template v-if="isShowFilter">
                        <v-btn
                          class="mb-2 ma-1"
                          dark
                          color="primary"
                          @click="isShowFilter = false"
                          :title="appheader_button_hide_filter"
                        >
                          <v-icon dark>mdi-filter-variant-remove</v-icon>
                        </v-btn>
                      </template>

                      <template v-else>
                        <v-btn
                          class="mb-2 ma-1"
                          dark
                          color="primary"
                          @click="isShowFilter = true"
                          :title="appheader_button_show_filter"
                        >
                          <v-icon dark>mdi-filter-variant</v-icon>
                        </v-btn>
                      </template>
                    </v-toolbar-title>

                    <v-divider class="mx-4" inset vertical></v-divider>

                    <v-btn
                      color="primary"
                      @click="loadCardsList"
                      class="mb-2 ma-1"
                      :title="home_button_refresh"
                      :disabled="isloading"
                    >
                      <v-icon>mdi-refresh</v-icon>
                    </v-btn>


                    <v-spacer></v-spacer>
<!- 
                    <v-btn
                      color="primary"
                      v-print="'#printTable'"
                      class="mb-2 ma-1"
                      :disabled="isloading"
                    >
                      <v-icon center>mdi-printer</v-icon>
                    </v-btn>
   ->
                  </v-toolbar>
                </template>
 -->

                <template v-slot:[`item.R_FIO`]="{ item }">
                  <div style="text-align:center">
                    {{item.R_F}} 
                    {{item.R_I}} 
                    {{item.R_O}}<br>
                  </div>
                </template>

                <template v-slot:[`item.R_DATE_BEGEND`]="{ item }">
                  <div style="text-align:center">
                    <!-- <template v-if="item.R_DATE_BEG">с </template> -->
                    {{getDateTime(item.R_DATE_BEG)}}
                    <!-- <template v-if="item.R_DATE_BEG">-</template> -->
                    <br>
                    <!-- <template v-if="item.R_DATE_END">по</template> -->
                    {{getDateTime(item.R_DATE_END)}}<br>
                  </div>
                </template>

                <template v-slot:[`item.R_DATE_BEG`]="{ item }">
                  <div style="text-align:center">
                    {{getDateTime(item.R_DATE_BEG)}}
                  </div>
                </template>

                <template v-slot:[`item.R_DATE_END`]="{ item }">
                  <div style="text-align:center">
                    {{getDateTime(item.R_DATE_END)}}
                  </div>
                </template>

              </v-data-table>

          </v-card>
        </v-col>
      </v-row>

 

<!-- <pre>{{JSON.stringify(cardsList, null, 2)}}</pre> -->

<!-- <pre>{{JSON.stringify(dictionary, null, 2)}}</pre> -->


  </v-container>
</template>

<script>
//const config = require("@/config.json");

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import 'vue2-datepicker/locale/ru';

import moment from 'moment'


import { mapGetters } from "vuex";
import { mapActions } from "vuex";

export default {
  name: "FilterCard",

  components: {
    DatePicker,
  },

  data: () => ({
    isloading: false,
    currentPage: 1,
    itemsPerPage: 20,
    // clear: true,
    home_datatable_loadingtext: 'Загрузка... Пожалуйста, подождите',
    home_datatable_nodataavailable: 'Нет данных',    //  No data available
    home_datatable_itemsperpage: 'Строк на странице:', 
    home_datatable_itemsperpage_all: 'Все', 
    // ----------------------------------------
    appheader_button_hide_filter: 'Скрыть фильтр',
    appheader_button_show_filter: 'Показать фильтр',
    appheader_cancel: 'Отмена',
    home_datatable_search: 'Поиск',
    home_button_clear: 'Очистить',
    home_button_select: 'Выбрать',
    home_button_refresh: 'Обновить',
    home_button_add: 'Создать',
    home_button_delete: 'Удалить',
    home_button_edit: 'Редактировать',
    // ----------------------------------------
    no_data_text: '',   //'Нет данных',
    // ----------------------------------------

    filter: {
      PRINTED: null,
      UNLOADED: null,

      P_ID_CARD: null,
      P_FFLAG: null,
      P_ID_USER_SELF: null,
      P_ID_USER: null,
      P_ID_TTYPE: null,
      P_ID_TTYPE_CATEGOR: null,
      P_ID_TTYPE_CITIZEN: null,
      P_ID_TTYPE_STATUS: null,
      P_ID_TTYPE_PASS: null,
      P_ID_ORG: null,
      P_ID_EVENT: null,
      P_F: null,
      P_I: null,
      P_O: null,
      P_F_LAT: null,
      P_I_LAT: null,
      P_DATE_ACT_1: null,
      P_DATE_ACT_2: null,
      P_DATE_BEG_1: null,
      P_DATE_BEG_2: null,
      P_DATE_END_1: null,
      P_DATE_END_2: null,
      P_DATE_BIRTH_1: null,
      P_DATE_BIRTH_2: null,
      P_PASS_DATE_1: null,
      P_PASS_DATE_2: null,
      P_PASS_SER: null,
      P_PASS_NUM: null,
      P_E_MAIL: null,
      P_PHONE: null,
      P_BARCODE: null,
      P_ID_USER_ACCEPT: null,
      P_ID_TTYPE_REASON: null,
      P_RFID: null,
      P_FANID: null,
      P_ID_DEP: null,
      P_ID_EMPL: null,
      P_ID_TTYPE_KPP: null,
      P_ID_TTYPE_DEST: null,
      

      Ticketid: null,
      Cardid: null,

      Barcode: null,
      EntryText: null,
      AreaText: null,
      RowNum: null,
      SitNum: null,

      RusF: null,
      RusI: null,
      RusO: null,

      EngF: null,
      EngI: null,
      EngO: null,

      DocStatusID: null,
      Email: null,
      Phone: null,
      Spectatorid: null,

      // datefrom: null,
      // timefrom: null,
      // dateto: null,
      // timeto: null,
      datetimefrom: null,
      datetimeto: null,

      CitizenShipID: null,
      BirthDate: null,
      IdentDocTypeID: null,
      DocCode: null,
      IssueDate: null,
    },
    isShowFilter: true,    

  }),

  computed: {
    ...mapGetters({
      userId: "account/userId",
      online: "account/online",
      orgId: "account/orgId",
      isEnterMode: "account/isEnterMode",

      patternId: "patterns/selectedIndex",
      cardsList: "patterns/cardsList",
      dictStatus: "patterns/dictStatus",
      dictionary: "patterns/dictionary",
    }),


    printed_items () { 
      return [
        { ID: 1024, NAME: 'Распечатанные' },
        { ID: 2048, NAME: 'Нераспечатанные' },
      ]
    },

    unloaded_items () { 
      return [
        { ID: 8192, NAME: 'Выгруженные' },
        { ID: 64, NAME: 'Невыгруженные' },
      ]
    },

    datatable_headers() {
      return [
        {
          text: "№ заявки",
          value: "R_ID_CARD",
          divider: true,
          align: 'center',
          class: "blue lighten-2",
        },
        {
          text: "ФИО",
          value: "R_FIO",
          divider: true,
          align: 'center',
          class: "blue lighten-2",
        },
        {
          text: "Тип",
          value: "R_TTYPE",
          divider: true,
          align: 'center',
          class: "blue lighten-2",
        },
        {
          text: "Категория",
          value: "R_TTYPE_CATEGOR",
          divider: true,
          align: 'center',
          class: "blue lighten-2",
        },
        {
          text: "Статус",
          value: "R_STATUS",
          divider: true,
          align: 'center',
          class: "blue lighten-2",
        },
        // {
        //   text: "Действует",
        //   value: "R_DATE_BEGEND",
        //   divider: true,
        //   align: 'center',
        //   class: "blue lighten-2",
        //   sortable: false,
        // },
        {
          text: "Действует с",
          value: "R_DATE_BEG",
          divider: true,
          align: 'center',
          class: "blue lighten-2",
          sortable: false,
        },
        {
          text: "Действует по",
          value: "R_DATE_END",
          divider: true,
          align: 'center',
          class: "blue lighten-2",
          sortable: false,
        },
        {
          text: "Гражданство",
          value: "R_TTYPE_CITIZEN",
          divider: true,
          align: 'center',
          class: "blue lighten-2",
        },
        {
          text: "Организация",
          value: "R_ORG",
          divider: true,
          align: 'center',
          class: "blue lighten-2",
        },
        {
          text: "Событие",
          value: "R_EVENT",
          divider: true,
          align: 'center',
          class: "blue lighten-2",
        },


      ];
    },


  },

  methods: {
    ...mapActions("patterns", [
      "AddCardField",
      "CreateCard",
      "GetFideInfo",
      "GetFideAPIData",
      "GetCardsList",
      "GetDictStatus",
      "getDictionary",
      "getDictionaries",
    ]),
    ...mapActions("account", ["StartLoading", "StopLoading"]),

    handleDateInput(event, update) {
      let value = event.target.value.replace(/[^0-9]/g, "");

      if (value.length >= 3)
        value = value.substring(0, 2) + "." + value.substring(2);

      if (value.length >= 6)
        value = value.substring(0, 5) + "." + value.substring(5);

      if (value.length > 10) value = value.substring(0, 10);

      this.$forceUpdate();
      update(value);
    },

    handleTimeInput(event, update) {
      let value = event.target.value.replace(/[^0-9]/g, "");

      if (value.length >= 3)
        value = value.substring(0, 2) + ":" + value.substring(2);

      if (value.length > 5) value = value.substring(0, 5);

      this.$forceUpdate();
      update(value);
    },

    handleDateTimeInput(event, update) {
      let value = event.target.value.replace(/[^0-9]/g, "");

      if (value.length >= 3)
        value = value.substring(0, 2) + "." + value.substring(2);

      if (value.length >= 6)
        value = value.substring(0, 5) + "." + value.substring(5);

      if (value.length >= 11)
        value = value.substring(0, 10) + " " + value.substring(10);

      if (value.length >= 14)
        value = value.substring(0, 13) + ":" + value.substring(13);

      if (value.length > 16) value = value.substring(0, 16);

      this.$forceUpdate();
      update(value);
    },

    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [day, month, year].join(".");
    },

    onlyDigit($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;

      if (keyCode < 48 || keyCode > 57) {
        $event.preventDefault();
      } else if ($event.target.value == "0") {
        $event.target.value = "";
      }
    },


    //-----------------------------------------------
    getDateTime(date) {
      if (date)
        return moment(date).format('DD.MM.YYYY HH:mm:ss (Z)')
      else
        return null
    },

    //-----------------------------------------------
    getDateTimeShort(date) {
      if (date)
        return moment(date).format('DD.MM.YYYY HH:mm (Z)')
      else
        return null
    },   


    //-----------------------------------------------
    clearFilter() {
      // console.log("$$$$$$$$$ clearFilter");

      for (const prop in this.filter) {
        this.filter[prop] = null;
      }

      // VueCookies.remove(this.filter_name);
    },



    async loadCardsList() {

      this.StartLoading();

      // console.log(this.filter.PRINTED, this.filter.PRINTED == 0, this.filter.PRINTED == 0 ? 1024 : 2048, this.filter.PRINTED ? (this.filter.PRINTED == 0 ? 1024 : 2048) : 0 )

      this.GetCardsList(
        {
          P_ID_CARD: 0,// P_ID_CARD BIGINT
          P_FFLAG: // P_FFLAG BIGINT
            (this.filter.PRINTED ?? 0) + 
            (this.filter.UNLOADED ?? 0) + 
            (this.filter.P_DATE_BEG_1 || this.filter.P_DATE_BEG_2 ? 4 : 0) + 
            (this.filter.P_DATE_END_1 || this.filter.P_DATE_END_2 ? 8 : 0) + 
            16384,
          //    P_FFLAG             bigint        , //     1 - карта удалена
          //                                          //     2 - поиск по DATE_ACT
          //                                        //     4 - поиск по DATE_BEG
          //                                        //     8 - поиск по DATE_END
          //                                          //    16 - поиск по DATE_BIRTH
          //                                          //    32 - поиск по PASS_DATE_GIVEN
          //                                        //    64 - только НЕвыгруженные пропуска
          //                                          //   128 - только   оправленные QR-коды
          //                                          //   256 - только НЕоправленные QR-коды
          //                                          //   512 - поиск по сессиям, разрешённым для посещения
          //                                        //  1024 - только   распечатанные
          //                                        //  2048 - только нераспечатанные
          //                                          //  4096 - выгрузка в СКД: исключить карты с некоторыми статусами
          //                                        //  8192 - только выгруженные пропуска
          //                                          // 16384 - НЕ формировать список USER_CARD
          
          P_ID_USER_SELF: 0,// P_ID_USER_SELF BIGINT
          P_ID_USER: this.userId, //0,//***** P_ID_USER BIGINT
          P_ID_TTYPE: this.filter.P_ID_TTYPE ?? 0,                    //***** P_ID_TTYPE BIGINT
          P_ID_TTYPE_CATEGOR: this.filter.P_ID_TTYPE_CATEGOR ?? 0,    //***** P_ID_TTYPE_CATEGOR BIGINT
          P_ID_TTYPE_CITIZEN: this.filter.P_ID_TTYPE_CITIZEN ?? 0,    //***** P_ID_TTYPE_CITIZEN BIGINT
          P_ID_TTYPE_STATUS: this.filter.P_ID_TTYPE_STATUS ?? 0,      //***** P_ID_TTYPE_STATUS BIGINT
          P_ID_TTYPE_PASS: this.filter.P_ID_TTYPE_PASS ?? 0,          // P_ID_TTYPE_PASS BIGINT
          P_ID_ORG: this.orgId,     //this.filter.P_ID_ORG ?? 0,                        //***** P_ID_ORG BIGINT
          P_ID_EVENT: this.filter.P_ID_EVENT ?? 0,                    //***** P_ID_EVENT BIGINT
          P_F: this.filter.P_F ?? '',                                 // ***** P_F D_LONG_FIO
          P_I: this.filter.P_I ?? '',                                 // ***** P_I D_FIO
          P_O: this.filter.P_O ?? '',                                 // ***** P_O D_FIO
          P_F_LAT: '',// P_F_LAT D_FIO
          P_I_LAT: '',// P_I_LAT D_FIO
          P_DATE_ACT_1: null,// P_DATE_ACT_1 DATE
          P_DATE_ACT_2: null,// P_DATE_ACT_2 DATE
          P_DATE_BEG_1: this.filter.P_DATE_BEG_1 ? moment(this.filter.P_DATE_BEG_1).format('YYYY-MM-DD') : '1999-01-01',  //this.filter.P_DATE_BEG_1,//***** P_DATE_BEG_1 DATE
          P_DATE_BEG_2: this.filter.P_DATE_BEG_2 ? moment(this.filter.P_DATE_BEG_2).format('YYYY-MM-DD') : '2199-01-01',  //this.filter.P_DATE_BEG_2,//***** P_DATE_BEG_2 DATE
          P_DATE_END_1: this.filter.P_DATE_END_1 ? moment(this.filter.P_DATE_END_1).format('YYYY-MM-DD') : '1999-01-01',  //this.filter.P_DATE_END_1,//***** P_DATE_END_1 DATE
          P_DATE_END_2: this.filter.P_DATE_END_2 ? moment(this.filter.P_DATE_END_2).format('YYYY-MM-DD') : '2199-01-01',  //this.filter.P_DATE_END_2,//***** P_DATE_END_2 DATE
          P_DATE_BIRTH_1: null,// P_DATE_BIRTH_1 DATE
          P_DATE_BIRTH_2: null,// P_DATE_BIRTH_2 DATE
          P_PASS_DATE_1: null,// P_PASS_DATE_1 DATE
          P_PASS_DATE_2: null,// P_PASS_DATE_2 DATE
          P_PASS_SER: '',// P_PASS_SER VARCHAR(20)
          P_PASS_NUM: '',// P_PASS_NUM VARCHAR(20)
          P_E_MAIL: this.filter.P_E_MAIL ?? '',// P_E_MAIL D_IDENT
          P_PHONE: this.filter.P_PHONE ?? '',// P_PHONE D_IDENT
          P_BARCODE: '',// P_BARCODE D_LONG_FIO 
          P_ID_USER_ACCEPT: 0,// P_ID_USER_ACCEPT BIGINT
          P_ID_TTYPE_REASON: 0,// P_ID_TTYPE_REASON BIGINT
          P_RFID: '',// P_RFID D_FIO
          P_FANID: this.filter.P_FANID ?? '',
          P_ID_DEP: 0,// P_ID_DEP BIGINT
          P_ID_EMPL: 0,// P_ID_EMPL BIGINT
          P_ID_TTYPE_KPP: 0,// P_ID_TTYPE_KPP BIGINT
          P_ID_TTYPE_DEST: 0// P_ID_TTYPE_DEST BIGINT    
        }    
      )
        .then((result) => {
          const res = result.result;
          const error = result.error;

          // console.log(result)

          if (error) {
            this.$fire({
              text: error.toString(),
              type: "error",
            });
          }

          if (res) {
            this.currentPage = 1;

            // console.log(res)
          }

          return true;
        })
        .then(() => {
            // console.log('then/////')
        })
        .catch((err) => {
          this.$fire({
            text: err.toString(),
            type: "error",
          });
        })
        .finally(() => {
          this.StopLoading();
          // if (cardId != null) {
          //   this.$fire({
          //     text: "Заявка создана. Номер заявки: " + cardId,
          //     type: "success",
          //   }).then(() => {
          //     this.clearRequest();
          //   });
          // }
        });

      // console.log("cardsList=", this.cardsList)
    },

/*
    async loadDictStatus() {

      this.GetDictStatus()
        .then((result) => {
          const res = result.result;

          if (res) {
            console.log(res)
          }

          return true;
        })
        .then(() => {
            console.log('then/////')
        })
        .catch((err) => {
          this.$fire({
            text: err.toString(),
            type: "error",
          });
        });
    },
*/
    
  },


  //-----------------------------------------------

  mounted() {
    // console.log("mounted: loadCardsList");

    // this.loadCardsList();
    this.getDictionaries();
    
  },

};
</script>

<style scoped>
.mx-datepicker {
  margin-top: 0px;
  left: 0px;
  margin-bottom: 20px;
  padding: 0px;
  height: 40px;
  width: 250px;
}
.mx-input {
  height: 40px;
}
</style>
